import { CreateCorpResponse, CorpUIPayload } from 'src/types/Corp';
import {
  CateringServiceFeeResponseUI,
  CateringServiceFeePayloadUI,
} from 'src/types/CateringServiceFee';
import { createCorporate } from 'src/components/enterprise/features/Corporate/CreatePage/functions/createCorpApi';
import { setCateringServiceFee } from 'src/components/enterprise/features/Corporate/components/Form/CateringServiceFeeControl/api/cateringServiceFeeApi';
import { enableUniversalAccounts } from 'src/components/enterprise/features/Corporate/components/Form/UniversalLogin/api/enableUniversalAccountsApi';

export type CorporateSetupResult = {
  corpData: CreateCorpResponse;
  cateringServiceFeeData?: CateringServiceFeeResponseUI;
};

export const executeCorporateSetup = async (
  corporateData: CorpUIPayload,
  serviceFee: CateringServiceFeePayloadUI,
  universalAccountsEnabled: boolean
): Promise<CorporateSetupResult> => {
  const temServiceFee = { ...serviceFee };
  const corpData = await createCorporate(corporateData);
  temServiceFee.corpId = corpData.id;
  const cateringServiceFeeData = await setCateringServiceFee(temServiceFee);

  if (universalAccountsEnabled) {
    await enableUniversalAccounts(corpData.id);
  }

  return { corpData, cateringServiceFeeData };
};
